import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'blueimp-canvas-to-blob/js/canvas-to-blob.js';

import CCEvents, { EventNames } from '@companycam/companycam-events';
import CCEditor from '@companycam/companycam-webgleditor';

import { loadStickerResourceDefs } from 'actions/remoteResources';
import { useFetchAnnotations, useSaveAnnotations } from 'actions/annotations';
import { editorStickerKeyURLs } from '../../selectors/remoteResources';
import StickerChoices from './StickerChoices';

const PhotoEditor = ({
  dispatch,
  photoId,
  imageUri,
  imageTimeUnixS,
  onClose,
  stickerKeyURLs,
}) => {
  const [initialJsonString, setInitialJsonString] = useState('{}');
  const [initialJsonValid, setInitialJsonValid] = useState(false);

  const fetchAnnotations = useFetchAnnotations({ photoId });
  const saveAnnotations = useSaveAnnotations({ photoId });

  useEffect(() => {
    dispatch(loadStickerResourceDefs());
  }, [dispatch]);

  useEffect(() => {
    fetchAnnotations().then((jsonObject) => {
      setInitialJsonString(JSON.stringify(jsonObject));
      setInitialJsonValid(true);
    });
  }, [fetchAnnotations]);

  const handleSave = ({ dataURL, json: jsonString }) => {
    saveAnnotations({
      jsonObject: JSON.parse(jsonString),
      dataURL,
    });

    CCEvents.logEvent(EventNames.ANNOTATE_PHOTO);

    onClose();
  };

  if (!initialJsonValid) {
    return null;
  }

  return (
    <CCEditor
      imageURL={imageUri}
      imageTimeUnixS={imageTimeUnixS}
      initialJSON={initialJsonString}
      stickerKeyURLs={stickerKeyURLs}
      renderStickerChoices={({ onSelectSticker }) => (
        <StickerChoices onSelectSticker={onSelectSticker} />
      )}
      onCancel={onClose}
      onSave={handleSave}
    />
  );
};

PhotoEditor.propTypes = {
  photoId: PropTypes.number,
  imageUri: PropTypes.string,
  imageTimeUnixS: PropTypes.number,
  onClose: PropTypes.func,

  dispatch: PropTypes.func,
  stickerKeyURLs: PropTypes.array,
};

const mapStateToProps = (state) => ({
  stickerKeyURLs: editorStickerKeyURLs(state),
});

export default connect(mapStateToProps)(PhotoEditor);
